import BaseAdapter from '@linc-technologies/linced-common/adapters/base';

export default class Device extends BaseAdapter {
  namespace = 'notifications/v4';
  modelNamePlural = 'devices';
}
